export var categoryPathMap = {
    moderate: 'severe',
    normal: 'normal',
    mild: 'mild',
};
